import { createApp, h } from 'vue'
import App from './App.vue'
import axios from 'axios'
import { createPinia } from 'pinia';
import vuetify from './plugins/vuetify';

import './assets/tailwind.css';


//mport GoogleLogin from 'vue3-google-login';
//import axios from 'axios'
import router from './router'
import store from './store'
import { NMessageProvider } from 'naive-ui'

// Intercepta respostas com erro
axios.interceptors.response.use(
  response => response,
  error => {
    if (error.response && error.response.status === 401) {

      store.commit('setToken', null)
      localStorage.removeItem('token')

      router.push('/app/manager')
    }

    return Promise.reject(error)
  }
)


store.dispatch('initializeStore');

const app = createApp({
  render: () =>
    h(NMessageProvider, null, {
      default: () => h(App)
    })
})
const pinia = createPinia();

app.use(vuetify);
app.use(pinia)
app.use(store)
app.use(router)
app.mount('#app')
